<template>
   <div>
       机构设置
   </div>
</template>

<script>
  
  export default {
    name:'Olist',
    data(){
      return {
       
      }
    },
   
    methods: {
      
    }
  }
</script>

<style>

</style>